<template>
    <div>
        <div v-if="!isLoading">
            <select class="form-control form-control-lg" v-model="selectModel" v-if="!editable">
                <option :value="null">{{selectPlaceholder}}</option>            
                <option v-for="(o, ind) in selectOptions" :key="ind" :value="o[selectOptionValue]">{{o[selectOptionText]}}</option>
                <optgroup label="Add new">
                    <option value="edit" class="add-option">{{selectOptionCustomText}}</option>
                </optgroup>
                
            </select>
            <div class="row" style="position: relative;" v-else>
                <div class="col">
                    <i class="fas fa-times input-clear" @click="undoCustomOption"></i>
                    <input class="form-control form-control-lg editable-option" v-model="addOptionModel" :placeholder="customInputPlaceholder"/>    
                </div>                    
            </div>
        </div>  
        <div v-else class="d-flex justify-content-center my-4">
            <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>          
    </div>
</template>

<script>
export default {
    name: 'MultiRoleSelect',
    props: {
        selectPlaceholder: {
            type: String,
            default: 'Select'
        },
        selectOptions: {
            type: Array | null,
            required: true            
        },
        selectOptionText: {
            type: String,
            required: true
        },
        selectOptionValue: {
            type: String,
            required: true
        },
        selectOptionCustomText: {
            type: String,
            required: true
        },
        customInputPlaceholder: {
            type: String,
            default: 'Add data here...'
        },
        isCustomOption: {
            type: Boolean,
            default: false
        },
        isLoading: {
            type: Boolean,
            default: false
        },
        feedbackValue: {
            type: String | Array | Object | Number
        }
    },
    data: () => ({
        selectModel: null,
        addOptionModel: "",
        editable: false
    }),
    methods: {
        undoCustomOption() {
            this.addOptionModel = "";
            this.selectModel = null;
            this.editable = false;
            this.$emit('custom-option', 'stop-edit');
        }
    },
    watch: {
        selectModel(val) {
            if(val === 'edit') {
                this.editable = true;
                this.$emit('custom-option', 'edit');
                this.selectModel = 0;
            }
            this.$emit("input", val);
        },
        addOptionModel(val) {
            this.$emit("custom-option", val);
        },
        isCustomOption(val) {
            if(val) {
                this.editable = true;
                this.selectModel = 0;
            } else {
                this.editable = false;
                this.selectModel = null;
                this.addOptionModel = "";
            }            
        },
        feedbackValue(val) {
            if (val !== this.selectModel) {
                this.selectModel = val;
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.input-clear {
    position: absolute;
    right: 23px;
    top: 20px;
    opacity: 0.7;
    font-size: 25px;    
    &:hover {
        cursor: pointer;
    }
}

.add-option {
    background-color: #007bff;
    color: #fff;
}

.editable-option {
    margin-top: 8px;
    margin-bottom: 8px;
}

</style>